import React, {Fragment} from 'react';
import {useSelector} from 'react-redux';
import DatePicker from 'react-datepicker';
// import "react-datepicker/dist/react-datepicker.css";
import {STYLES} from 'core/constants/uiConstants';
import {usePCTranslation} from 'core/hooks';
import {TooltipText, TooltipIcon} from 'core/uicore';

const Datebox = ({
  getchangeCallback,
  getfocusCallback,
  lostfocusCallback,
  stateData,
  name,
  text,
  type,
  autoFocus,
  refItem,
  propStyle,
  format,
  minDate = null,
  maxDate = null,
}) => {
  const {t} = usePCTranslation();
  const {controlItem} = useSelector((state) => ({
    controlItem: state.setupItems.controlItems ? state.setupItems.controlItems[name] : null,
  }));

  const controlOnChange = (date) => {
    //event.persist();
    //let value = formattedDate(date);
    //console.log(value);
    let event = {
      target: {
        name,
        date,
      },
    };
    getchangeCallback(event, name, date);
  };

  const controlOnFocus = (date) => {
    //let value = formattedDate(date);
    //console.log(value);
    let event = {
      target: {
        name,
        date,
      },
    };
    getfocusCallback(event, event.target.name, event.target.date);
    //DO NOT propagate this event up as it should only be for the current control
    //event.stopPropagation();
  };
  const controlOnLostFocus = (date) => {
    //let value = formattedDate(date);
    //console.log(value);
    let event = {
      target: {
        name,
        date,
      },
    };
    lostfocusCallback(event, event.target.name, event.target.date);
    //DO NOT propagate this event up as it should only be for the current control
    //event.stopPropagation();
  };

  let containerClass = `${STYLES.INPUTCONTAINER} ${STYLES.DATE} ${propStyle.datecontainer}`;
  if (controlItem && controlItem.displayDisabled) containerClass += ' disabled';
  if (controlItem && controlItem.displayHidden) containerClass += ' hiddenField';
  const dateInput = () => (
    <div className="DATEPICKER" id={name}>
      <DatePicker
        selected={stateData[name]}
        onChange={(date) => controlOnChange(date)}
        disabled={controlItem && controlItem.displayDisabled}
        dateFormat={format}
        minDate={minDate}
        maxDate={maxDate}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        ref={refItem}
        placeholderText={format.toLowerCase()}
        name={name}
      />
    </div>
  );
  return (
    <div id={name} className={`DATEPICKERCONTAINER ${containerClass}`}>
      {!controlItem.showTooltip ? (
        <Fragment>
          {controlItem.showLabel && (
            <label
              className={`DATEPICKERLABEL ${STYLES.BASIC} ${STYLES.LABEL} ${propStyle.label}`}
              id={name}>
              {t(`${name}-caption`)}
            </label>
          )}
          {dateInput()}
        </Fragment>
      ) : controlItem.showTooltipIcon ? (
        <Fragment>
          <label
            className={`DATEPICKERLABEL ${STYLES.BASIC} ${STYLES.LABEL} ${propStyle.label}`}
            id={name}>
            {t(`${name}-caption`)}
          </label>
          <div className={`${STYLES.TOOLTIP}`} id={name}>
            <TooltipText name={name} />
            <TooltipIcon name={name} />
          </div>
          {dateInput()}
        </Fragment>
      ) : (
        <div className={`${STYLES.TOOLTIP}`} id={name}>
          <label
            className={`DATEPICKERLABEL ${STYLES.BASIC} ${STYLES.LABEL} ${propStyle.label}`}
            id={name}>
            {t(`${name}-caption`)}
          </label>
          {dateInput()}
          <TooltipText name={name} />
        </div>
      )}
    </div>
  );
};
Datebox.defaultProps = {
  format: 'dd/MM/yyyy',
};
export {Datebox};
